import { useTranslation } from '../../../translations';
import { useLanguageControls } from '../../useLanguageControls';

export default function useMonthName() {
  const { t } = useTranslation();
  const { getLocalizedText } = useLanguageControls();

  const currentMonthIndex = new Date().getMonth();
  const months = t('rating.months', { returnObjects: true });
  const monthName = months[currentMonthIndex];
  const monthTextObj = t('rating.month', { returnObjects: true });
  const monthTextRaw = getLocalizedText(monthTextObj);
  return monthTextRaw.replace('{{month}}', monthName);
}
